import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dumpops_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const mine = JSON.parse(localStorage.getItem("dumpops_mine") || "null");
  if (mine?.mine_id) cfg.headers["X-Mine-Id"] = mine.mine_id;
  return cfg;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (
      err.response?.status === 401 &&
      localStorage.getItem("dumpops_token") &&
      !err.config.url.includes("/auth/login")
    ) {
      localStorage.removeItem("dumpops_token");
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export const login = (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchMe = () => client.get("/auth/me").then((r) => r.data);

export const fetchAreas = () => client.get("/areas").then((r) => r.data);
export const addArea = (name) => client.post("/areas", { name }).then((r) => r.data);
export const deleteArea = (id) => client.delete(`/areas/${id}`).then((r) => r.data);
export const addMine = (areaId, name) => client.post(`/areas/${areaId}/mines`, { name }).then((r) => r.data);
export const deleteMine = (areaId, mineId) => client.delete(`/areas/${areaId}/mines/${mineId}`).then((r) => r.data);

export const fetchUsers = () => client.get("/users").then((r) => r.data);
export const addUser = (payload) => client.post("/users", payload).then((r) => r.data);
export const removeUser = (id) => client.delete(`/users/${id}`).then((r) => r.data);

export const fetchDumpers = () => client.get("/dumpers").then((r) => r.data);
export const addDumper = (number) => client.post("/dumpers", { number }).then((r) => r.data);
export const removeDumper = (id) => client.delete(`/dumpers/${id}`).then((r) => r.data);

export const fetchShovels = () => client.get("/shovels").then((r) => r.data);
export const addShovel = (number) => client.post("/shovels", { number }).then((r) => r.data);
export const removeShovel = (id) => client.delete(`/shovels/${id}`).then((r) => r.data);

export const fetchActiveShift = () =>
  client.get("/shifts/active").then((r) => (r.data && r.data.id ? r.data : null));
export const fetchShifts = () => client.get("/shifts").then((r) => r.data);
export const startShift = (name) => client.post("/shifts", { name }).then((r) => r.data);
export const endShift = (id) => client.post(`/shifts/${id}/end`).then((r) => r.data);
export const saveAssignments = (id, assignments) =>
  client.put(`/shifts/${id}/assignments`, { assignments }).then((r) => r.data);

export const recordTrip = (dumper_id) => client.post("/trips", { dumper_id }).then((r) => r.data);
export const recordAllTrips = () => client.post("/trips/all").then((r) => r.data);
export const recordShovelTrips = (shovel_id) => client.post("/trips/shovel", { shovel_id }).then((r) => r.data);
export const undoTrip = (dumper_id) => client.delete(`/trips/last/${dumper_id}`).then((r) => r.data);

export const fetchReport = (shiftId) => client.get(`/shifts/${shiftId}/report`).then((r) => r.data);

export const fetchPublicAreas = () => client.get("/public/areas").then((r) => r.data);
export const fetchPublicShifts = (mineId) => client.get(`/public/mines/${mineId}/shifts`).then((r) => r.data);
export const fetchPublicReport = (shiftId, mineId) =>
  client.get(`/public/mines/${mineId}/shifts/${shiftId}/report`).then((r) => r.data);
